<template>
<div class="chapter">
<div class="inner_page">
<div class="body">
<section epub:type="halftitlepage">
<p class="sp"> </p>
<p class="TPHT"><b>In Search of Radical Theology</b></p>
</section>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// halftitle1.vue?7275ee24